"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetchRequest_1 = require("./fetchRequest");
var UiConfigurations_1 = require("../api/UiConfigurations");
var UrlParam_1 = require("../helpers/UrlParam");
var UiConfigurationConnector = /** @class */ (function () {
    function UiConfigurationConnector(baseUrl) {
        this.baseUrl = baseUrl;
    }
    /**
     * Save new UI Configuration
     * @param uiConfig
     * @param productName
     */
    UiConfigurationConnector.prototype.saveUiConfiguration = function (uiConfig, productName) {
        var params = new URLSearchParams();
        UrlParam_1.appendParam(params, 'name', productName);
        return fetchRequest_1.fetchWrappedRequest(UiConfigurations_1.saveUiConfigurationUsingPOST(uiConfig, params), this.baseUrl);
    };
    /**
     * Get entities from a given UI Configuration
     * @param name
     * @param uiConfigParameters
     */
    UiConfigurationConnector.prototype.getEntitiesWithUiConfig = function (name, uiConfigParameters) {
        var params = new URLSearchParams();
        if (uiConfigParameters) {
            UrlParam_1.appendParam(params, 'page', uiConfigParameters.page);
            UrlParam_1.appendParam(params, 'size', uiConfigParameters.size);
            UrlParam_1.appendParam(params, 'partyId', uiConfigParameters.partyId);
        }
        return fetchRequest_1.fetchWrappedRequest(UiConfigurations_1.getEntitiesWithUiConfigUsingGET(name, params), this.baseUrl);
    };
    /**
     * Update UI Configuration
     * @param name
     * @param data
     * @param uiConfigParameters
     * @param triggerInviteAdminFlow
     * @param paymentDetailId
     */
    UiConfigurationConnector.prototype.updateEntities = function (name, data, uiConfigParameters, triggerInviteAdminFlow, paymentDetailId) {
        var params = new URLSearchParams();
        if (uiConfigParameters) {
            UrlParam_1.appendParam(params, 'page', uiConfigParameters.page);
            UrlParam_1.appendParam(params, 'size', uiConfigParameters.size);
            UrlParam_1.appendParam(params, 'partyId', uiConfigParameters.partyId);
        }
        UrlParam_1.appendParam(params, 'triggerInviteAdminFlow', triggerInviteAdminFlow);
        UrlParam_1.appendParam(params, 'PaymentDetailId', paymentDetailId);
        return fetchRequest_1.fetchWrappedRequest(UiConfigurations_1.updateEntitiesUsingPUT(name, data, params), this.baseUrl);
    };
    return UiConfigurationConnector;
}());
exports.default = UiConfigurationConnector;
